import { useEffect, useState } from 'react';
import { useAtom } from 'jotai/index';
import {
  documentTableRows,
  fundIdAtom,
  loadDocumentTable,
  showLoaderOnPageLoad,
} from '~/atoms/document/documentAtoms';
import { useSetAtom } from 'jotai';

export const useDocumentLoader = () => {
  const [reload, setReload] = useState(false);
  const [isReloading, setIsReloading] = useState(false);
  const [, loadDocumentsAtom] = useAtom(loadDocumentTable);
  const [documents] = useAtom(documentTableRows);
  const showLoader = useSetAtom(showLoaderOnPageLoad);
  const [atomFundId] = useAtom(fundIdAtom);
  const loadDocuments = async (fundId?: string) => {
    if (fundId !== atomFundId) return;
    await loadDocumentsAtom(fundId);
  };

  const doReload = async (id: string) => {
    if (isReloading) return;
    setIsReloading(true);
    await new Promise((resolve) => setTimeout(resolve, 10000));
    await loadDocuments(id);
  };
  useEffect(() => {
    if (reload && atomFundId) {
      setReload(false);
      doReload(atomFundId);
    }
  }, [reload]);

  useEffect(() => {
    if (atomFundId) {
      showLoader();
      loadDocuments(atomFundId);
    }
  }, [atomFundId]);

  useEffect(() => {
    if (documents) {
      let hasProcessingDocuments = false;
      documents.forEach((doc) => {
        // we need to start polling when document is pending otherwise we do not get the status update after uplaoding
        if (
          doc.extractionStatus === 'started' ||
          doc.extractionStatus === 'pending'
        ) {
          hasProcessingDocuments = true;
        }
      });
      setIsReloading(false);
      setReload(hasProcessingDocuments);
    }
  }, [documents]);

  return { loadDocuments, documents };
};
